// extracted by mini-css-extract-plugin
export default {"modalOverlay":"oz-z","modalContent":"pz-z","header":"qz-z","close":"rz-z"};